<template>
  <div>
    <el-select v-model="type" @change="changeType">
      <el-option v-for="item in [1, 2]" :key="item" :label="`切换${item}个表头`" :value="item"> </el-option>
    </el-select>
    <el-table-block
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      :column="tableData.column"
      :data="tableData.data"
    >
    </el-table-block>
  </div>
</template>

<script>
// eslint-disabled
export default {
  data() {
    return {
      type: 1,
      tableData: {
        column: [
          {
            type: 'selection'
          },
          {
            type: 'index',
            label: '序号',
            width: 60,
            align: 'center',
            fixed: true
          },
          {
            prop: 'data_time',
            label: '监测时间',
            align: 'center',
            width: 200,
            fixed: true
          },
          {
            prop: 'work',
            label: '工作参数',
            align: 'center',
            children: [
              // {
              //   prop: 'i13114',
              //   label: '量程校准时间',
              //   align: 'center',
              //   children: [
              //     {
              //       prop: 'i13114_value',
              //       label: '监测值',
              //       align: 'center',
              //       width: 180
              //     },
              //     {
              //       prop: 'i13114_range',
              //       label: '标准范围',
              //       width: 160,
              //       align: 'center'
              //     }
              //   ]
              // },
              {
                prop: 'i13109',
                label: '调零时间',
                align: 'center',
                children: [
                  {
                    prop: 'i13109_value',
                    label: '监测值',
                    align: 'center',
                    width: 180
                  },
                  {
                    prop: 'i13109_range',
                    label: '标准范围',
                    width: 160,
                    align: 'center'
                  }
                ]
              },
              {
                prop: 'i13001',
                label: '测量量程',
                align: 'center',
                children: [
                  {
                    prop: 'i13001_value',
                    label: '监测值',
                    align: 'center',
                    width: 180
                  },
                  {
                    prop: 'i13001_range',
                    label: '标准范围',
                    width: 160,
                    align: 'center'
                  }
                ]
              },
              {
                prop: 'i13115',
                label: '量程校准系数',
                align: 'center',
                children: [
                  {
                    prop: 'i13115_value',
                    label: '监测值',
                    align: 'center',
                    width: 180
                  },
                  {
                    prop: 'i13115_range',
                    label: '标准范围',
                    width: 160,
                    align: 'center'
                  }
                ]
              },
              {
                prop: 'i13116',
                label: '量程校准浓度',
                align: 'center',
                children: [
                  {
                    prop: 'i13116_value',
                    label: '监测值',
                    align: 'center',
                    width: 180
                  },
                  {
                    prop: 'i13116_range',
                    label: '标准范围',
                    width: 160,
                    align: 'center'
                  }
                ]
              }
            ]
          },
          {
            prop: 'i12001',
            label: '运行状态',
            align: 'center',
            fixed: 'right'
          }
        ],
        data: []
      }
    }
  },
  mounted() {
    this.tableData.data = this.fetchTableData()
  },
  methods: {
    handleSelectionChange(val) {
      alert(JSON.stringify(val, null, 4))
    },

    changeType() {
      this.fetchHeader().then(([data]) => {
        this.tableData.column.forEach((v, i) => {
          if (v.prop === 'data_time') {
            this.tableData.column[i + 1].children.unshift(data)
            // this.tableData.column.splice(i, 0, data)
          }
        })
      })
    },

    fetchHeader() {
      return new Promise((resolve) => {
        resolve([
          {
            prop: 'i13114',
            label: '量程校准时间->添加',
            align: 'center',
            children: [
              {
                prop: 'i13114_value',
                label: '监测值',
                align: 'center',
                width: 180
              },
              {
                prop: 'i13114_range',
                label: '标准范围',
                width: 160,
                align: 'center'
              }
            ]
          }
        ])
      })
    },

    fetchTableData() {
      return [
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 00:00',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 00:10',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 00:20',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 00:30',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 00:40',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 00:50',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 01:00',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 01:10',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 01:20',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 01:30',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 01:40',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 01:50',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 02:00',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        },
        {
          pollutant_code: '010',
          i12001: '运行',
          i13001: '15.17900,20.00000-20.00000,1',
          mp_id: '140000000123245',
          equip_id: '14000000012325',
          data_time: '2021-03-29 02:10',
          ps_id: '140000000123',
          i13109: '2345.00000,20210225121600.00000-20210225121600.00000,0',
          i13116: '12.14300,15.90000-15.90000,1',
          i13115: '0.95000-1.05000,6.44900-6.44900,1',
          i13114: '235.00000,20210225121100.00000-20210225121100.00000,0',
          i13114_range: '235.00000',
          i13114_value: '20210225121100.00000-20210225121100.00000',
          i13114_status: '0',
          i13109_range: '2345.00000',
          i13109_value: '20210225121600.00000-20210225121600.00000',
          i13109_status: '0',
          i13001_range: '15.17900',
          i13001_value: '20.00000-20.00000',
          i13001_status: '1',
          i13115_range: '0.95000-1.05000',
          i13115_value: '6.44900-6.44900',
          i13115_status: '1',
          i13116_range: '12.14300',
          i13116_value: '15.90000-15.90000',
          i13116_status: '1'
        }
      ]
    }
  }
}
</script>
